<template>
  <div class="bdg-img">
    <!-- 背景颜色 -->
    <div class="bdg-cor">
      <div class="pop-wrap">
        <h1><span>Update your password</span></h1>
        <i class="icon-close" @click="hidelogin">×</i>
        <div v-if="!haveSubmit">
          <p>Enter a new password to update.</p>
          <h3>Your password must contain minimum of 8 characters</h3>
          <div class="inputItem">
            <i class="title">New Password</i>
            <input
              v-model="pswd"
              maxlength="16"
              type="password"
              @input="handleInput"
            />
          </div>
          <div class="inputItem" style="margin-bottom:42px">
            <i class="title">Re-type password</i>
            <input
              v-model="repswd"
              maxlength="16"
              type="password"
              v-bind:class="{ red: warn }"
              @input="handleInput"
            />
            <i v-if="warn" class="close" @click="clean('repswd')"></i>
            <strong v-if="warn" style="width:100%"
              >Your password don't match. Please try again</strong
            >
          </div>
          <button
            :class="{ disabled: disable }"
            :disabled="disable"
            class="colored"
            @click="save"
          >
            Save password
          </button>
        </div>
        <div v-if="haveSubmit">
          <p style="margin-bottom:140px">
            You have Successfully updated<br />your password.
          </p>
          <i class="home" style="cursor:pointer" @click="login"></i>
        </div>
      </div>
      <h5
        style="position:absolute;left:0;bottom:.5rem;width:100%;font-size:.22rem;line-height:.42rem;color:#FFFFFF;text-align:center;"
      >
        team@unifiproperty.com COPYRIGHT 2020
      </h5>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      haveSubmit: false,
      warn: false,
      disable: true,
      pswd: "",
      repswd: ""
    };
  },
  created() {
    console.log(this.$route.query.sessionId);
    console.log(this.$route.query.email);
    /*var that = this
    if (!that.$route.query.email || !that.$route.query.sessionId) {
        that.$box.alert('', 'error', 'error')
        return
    }*/
  },
  methods: {
    ...mapActions("login", ["update"]),
    hidelogin() {
      this.$router.replace("/login");
    },
    // 去掉空格，判断两个输入框都有内容，且分别大于7个字符时，按钮高亮
    handleInput() {
      var that = this;
      that.pswd = that.pswd.replace(/\s+/g, "");
      that.repswd = that.repswd.replace(/\s+/g, "");
      that.warn = false;
      if (that.pswd.length > 7 && that.repswd.length > 7) {
        that.disable = false;
      } else {
        that.disable = true;
      }
    },
    save() {
      var that = this;
      if (that.pswd !== that.repswd || that.pswd.length < 7) {
        that.warn = true;
        return;
      }
      that.$box.loadings();
      that.update({
        params: {
          email: decodeURI(that.$route.query.email),
          password: that.pswd,
          sessionId: decodeURI(that.$route.query.sessionId)
        },
        callback: that.callback
      });
    },
    callback(res) {
      var that = this;
      that.$box.loadings(2);
      if (res.data.code == 0) {
        that.haveSubmit = true;
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    clean(txt) {
      var that = this;
      if (txt == "pswd") {
        that.pswd = "";
      } else if (txt == "repswd") {
        that.repswd = "";
      }
      that.warn = false;
      that.disable = true;
    },
    login() {
      this.$router.replace("/login");
    }
  }
};
</script>

<style lang="scss" scoped>
.bdg-img {
  width: 100%;
  min-height: 100vh;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("https://s3-ap-southeast-2.amazonaws.com/com.unifiproperty/files/images/lALPBF8a6aDY23PNA6HNBG0_1133_929.png");
  position: relative;

  .bdg-cor {
    width: 100%;
    min-height: 100vh;
    background-color: rgba(0, 0, 0, 0.59);
    padding-bottom: 0.2rem;
  }
}

.pop-wrap {
  width: 7.02rem;
  height: 10.44rem;
  border-radius: 0.06rem;
  position: fixed;
  top: 50%;
  left: 50%;
  margin: -5.22rem 0 0 -3.51rem;
  background: #fff;
  overflow: hidden;

  .icon-close {
    position: absolute;
    top: 0.3rem;
    right: 0.2rem;
    display: block;
    width: 0.5rem;
    height: 0.5rem;
    color: #3f3f46;
    line-height: 0.55rem;
    font-size: 0.8rem;
    cursor: pointer;
    font-style: normal;
  }

  h1 {
    margin: 0.94rem auto 0.64rem auto;
    line-height: 0.58rem;
    font-size: 0.48rem;
    color: #3f3f46;
    text-align: center;
    font-family: ProximaNova-Semibold;
  }

  h1 span {
    position: relative;
  }

  h1 span:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0.6rem;
    width: 1.16rem;
    height: 0.06rem;
    background: #ffef00;
  }

  .inputItem {
    width: 100%;
    margin: 0.52rem auto 0 auto;
    position: relative;
    box-sizing: border-box;
    padding: 0 0.48rem;

    .title {
      display: block;
      font-style: normal;
      color: #908d90;
      font-size: 0.28rem;
      margin-bottom: 0.24rem;
    }

    input {
      width: 100%;
      height: 0.92rem;
      border-radius: 0.12rem;
      border: 1px solid #e0dde0;
      outline: none;
      transition: all 0.5s;
      box-sizing: border-box;
      padding-left: 0.36rem;
    }

    .red {
      border: 1px solid #ff4e4e;
    }

    .close {
      display: block;
      width: 1rem;
      height: 1rem;
      position: absolute;
      right: 0.48rem;
      top: 0.5rem;
      background-repeat: no-repeat;
      background-size: 0.3rem 0.3rem;
      background-position: center center;
      background-image: url("../../assets/null.png");
      cursor: pointer;
    }

    strong {
      font-weight: normal;
      position: absolute;
      left: 0.5rem;
      top: 1.5rem;
      font-size: 0.28rem;
      color: #ff4e4e;
    }
  }

  h4 {
    font-size: 0.28rem;
    line-height: 0.34rem;
    margin: 0.32rem 0.48rem 1.28rem 0;
    text-align: right;
    color: #8a878a;
    text-decoration: underline;
    cursor: pointer;
    text-align: right;
  }

  .colored {
    display: block;
    width: 3.6rem;
    height: 0.92rem;
    margin: 0 auto;
    background: #2cca73;
    border: none;
    border-radius: 0.12rem;
    font-size: 0.3rem;
    text-align: center;
    line-height: 0.92rem;
    cursor: pointer;
    color: #fff;
    transition: all 0.3s;
    font-family: ProximaNova-Semibold;
  }

  .disabled {
    background: #a1e4bf;
    cursor: not-allowed;
  }

  .icon-mail {
    display: block;
    width: 1.2rem;
    height: 0.7475rem;
    margin: 0 auto 1rem auto;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    background-image: url("../../assets/mail.png");
  }

  p {
    font-size: 0.28rem;
    color: #3f3f46;
    margin-bottom: 0.26rem;
    text-align: center;
    line-height: 0.42rem;
  }

  h3 {
    font-size: 0.24rem;
    color: #898689;
    text-align: center;
    margin-bottom: 0.66rem;
  }

  .home {
    display: block;
    width: 1.42rem;
    height: 1.31rem;
    margin: 2.72rem auto 0 auto;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    background-image: url("../../assets/home.png");
    cursor: pointer;
  }
}

.pop-wrap:after {
  content: "";
  width: 100%;
  height: 0.18rem;
  position: absolute;
  left: 0;
  top: 0;
  background: #ffef00;
}
</style>



// WEBPACK FOOTER //
// src/components/login/update.vue